/**
 * Owner: Masa Bayu
 * File: main.tsx
 * Date:Time: 2026-09-15 19:50
 * Description: QXRead React DOM entry.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyQxreadDesignTokens } from './ds';
import { ensureQxpHubSynced, resyncQxpHub } from './publication/hub-sync';
import { registerQxreadServiceWorker } from './pwa/pwa-register';
import './styles/tokens.css';
import './styles/shell.css';
import './styles/uiux.css';
import './styles/home-marketplace.css';
import './styles/home-marketplace-featured.css';
import './styles/home-marketplace-aside.css';
import './styles/reader-book.css';
import './styles/natural-reader.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('QXRead root element #root was not found.');
}

// Legacy-hash default hanya untuk root; deep link /author/:id dsb. mesti
// dipertahankan supaya router history (pathname) tidak ditimbus '#/' (§384).
if (!window.location.hash && window.location.pathname === '/') {
  window.location.hash = '#/';
}

applyQxreadDesignTokens(document.documentElement);

void registerQxreadServiceWorker('serviceWorker' in navigator ? navigator.serviceWorker : null);

// Fasa 3 — sinkron catalog + entitlement daripada qxp-hub (fail-soft; hub luar
// talian → catalog statik + entitlement setempat kekal). §422 K1 — promise yang
// sama dipakai reader deep-link melalui ensureQxpHubSynced.
// Stripe — pembeli pulang ke /read/:id?qxPaid=1. Webhook boleh sampai beberapa
// saat selepas redirect, jadi lawatan pulang ini mesti menilai semula entitlement
// (resync) dan bukan memakai memo sinkron pertama.
const kembaliDariStripe = new URLSearchParams(window.location.search).get('qxPaid') === '1';
void (kembaliDariStripe ? resyncQxpHub() : ensureQxpHubSynced());
window.addEventListener('qx-hub-published', () => {
  void resyncQxpHub();
});

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
